module.exports = __webpack_public_path__ + "static/img/knives41.cc50f64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives41.jpg
// module id = nKgw
// module chunks = 0